
<div class="container">
  <div class="row">
    <div class="col">
      <h3>You've successfully connected your stripe account.</h3>
      <p>This window will close automatically</p>
    </div>
  </div>
</div>
